import React from 'react';
import { motion } from 'framer-motion';
import { FaChevronDown } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const PageTemplate = ({ title, subtitle, children }) => {
  const { t } = useTranslation();
  return (
    <>
      {/* Video Hero Section */}
      <div className="h-screen w-full relative overflow-hidden" style={{ minHeight: '100vh', paddingBottom: '80px' }}>
        <video
          className="absolute top-1/2 left-1/2 w-full h-full object-cover transform -translate-x-1/2 -translate-y-1/2"
          src="/fenfakultesivideo.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
          <motion.h1 
            className="text-5xl md:text-7xl font-black text-white uppercase" 
            style={{ textShadow: '0px 5px 20px rgba(0,0,0,0.5)' }}
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          >
            {title}
          </motion.h1>
          {subtitle && (
            <motion.p 
              className="mt-4 text-lg md:text-xl text-white/90 font-medium max-w-2xl" 
              style={{ textShadow: '0px 2px 10px rgba(0,0,0,0.5)' }}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            >
              {subtitle}
            </motion.p>
          )}
        </div>
        
        {/* Animated Scroll Down Indicator */}
        <motion.div 
          className="absolute bottom-20 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center cursor-pointer group"
          onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="text-sm font-medium text-white/80 tracking-widest uppercase group-hover:text-white transition-colors duration-300">
            {t('common.scrollDown')}
          </span>
          <FaChevronDown className="w-6 h-6 mt-2 text-white animate-bounce" />
        </motion.div>
      </div>

      {/* Page Content */}
      <div className="relative bg-gray-50 -mt-20 rounded-t-3xl pt-16 pb-20 z-20">
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-lg shadow-xl p-8 md:p-12">
                 {children || <p className="text-gray-700">{t('common.pageComingSoon')}</p>}
            </div>
        </div>
      </div>
    </>
  );
};

export default PageTemplate; 